import { createActionConst } from '../../../utils/action.utils';

const EVENT_NAMESPACE = 'CALENDAR';

export const STORE_EVENT = createActionConst(EVENT_NAMESPACE, 'STORE_EVENT');
export const CLEAR_EVENT = createActionConst(EVENT_NAMESPACE, 'CLEAR_EVENT');
